import ApiService from './api';
import encryptData from '../config/encryptConfig';

class AuthService {
  // Login user
  async login(plain_email, plaint_password) {
    try {

      const password = encryptData(plaint_password);
      const email = encryptData(plain_email);
      const response = await ApiService.post('/auth/login', {
        email,
        
        password,
      });


      if (response.token) {
        // Store user data and token separately in localStorage
        const userData = response.user;
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('token', response.token);
        return { success: true, user: userData, token: response.token };
      }

      return { success: false, message: 'Invalid credentials' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  }

  // Logout user
  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    return { success: true };
  }

  // Get current user
  getCurrentUser() {
    const userData = localStorage.getItem('user');
    return userData ? JSON.parse(userData) : null;
  }

  // Check if user is authenticated
  isAuthenticated() {
    const user = this.getCurrentUser();
    const token = localStorage.getItem('token');
    return user && token;
  }

  // Check if user has specific role
  hasRole(role) {
    const user = this.getCurrentUser();
    return user && user.role === role;
  }

  // Check if user has any of the specified roles
  hasAnyRole(roles) {
    const user = this.getCurrentUser();
    return user && roles.includes(user.role);
  }

  // Get user profile
  async getProfile() {
    try {
      return await ApiService.get('/auth/profile');
    } catch (error) {
      throw error;
    }
  }

  // Refresh token
  async refreshToken() {
    try {
      const response = await ApiService.post('/auth/refresh');
      if (response.token) {
        localStorage.setItem('token', response.token);
        return { success: true, token: response.token };
      }
      return { success: false };
    } catch (error) {
      return { success: false, message: error.message };
    }
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
